import { render, staticRenderFns } from "./ReplyButton.html?vue&type=template&id=4c9e8bc4&scoped=true&"
import script from "./ReplyButton.js?vue&type=script&lang=js&"
export * from "./ReplyButton.js?vue&type=script&lang=js&"
import style0 from "./ReplyButton.scss?vue&type=style&index=0&id=4c9e8bc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9e8bc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
